module.exports = __webpack_public_path__ + "static/media/calendar-plus.b77e14f7.svg";